var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player"},[_c('video',{attrs:{"controls":"","autoplay":"","name":"media"}},[_c('source',{attrs:{"src":"https://broadcaster.cloudsdaleradio.com/radio/8000/CloudsdaleRadio.mp3","type":"audio/mpeg"}})])])
}]

export { render, staticRenderFns }